module.exports = __webpack_public_path__ + "static/img/plus.50955bf5.png";